import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BrainCircuit, ArrowRight, Bot } from "lucide-react";
import { api } from "../../lib/api";
import SignalCard from "./SignalCard";
import { useT } from "../../lib/i18n";

export default function AssistantWidget() {
  const t = useT();
  const [signals, setSignals] = useState(null);
  const [pending, setPending] = useState(0);

  const load = () => {
    api.get("/assistant/signals?limit=3").then((r) => setSignals(r.data.signals || [])).catch(() => setSignals([]));
    api.get("/agenda/proposals?status=pending").then((r) => setPending((r.data || []).length)).catch(() => {});
  };
  useEffect(load, []);

  return (
    <div className="pm-card p-5 mb-6" data-testid="dash-assistant-widget">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-violet-50 text-violet-700 flex items-center justify-center"><BrainCircuit size={16} /></div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-slate-500">AI Assistant</div>
            <h2 className="font-display text-lg font-bold tracking-tight">{t("Vandaag belangrijk")}</h2>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {pending > 0 && (
            <Link to="/agenda?tab=proposals" className="pm-pill pm-pill-amber text-[10px] flex items-center gap-1" data-testid="dash-agenda-proposals-pill"><Bot size={10} /> {pending > 1 ? t("{n} afspraakvoorstellen", { n: pending }) : t("{n} afspraakvoorstel", { n: pending })}</Link>
          )}
          <Link to="/assistant" className="text-xs font-bold text-emerald-700 flex items-center gap-1" data-testid="dash-assistant-open">{t("Alle signalen")} <ArrowRight size={12} /></Link>
        </div>
      </div>
      {signals === null && <div className="text-xs text-slate-400">{t("Laden…")}</div>}
      {signals && signals.length === 0 && <div className="text-sm text-slate-500" data-testid="dash-assistant-empty">{t("Geen openstaande signalen — alles onder controle.")}</div>}
      {signals && signals.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {signals.map((s) => <SignalCard key={s.id} signal={s} compact onFeedback={() => setSignals((l) => l.filter((x) => x.id !== s.id))} />)}
        </div>
      )}
    </div>
  );
}
